import { render, staticRenderFns } from "./banner-carousel.vue?vue&type=template&id=2f05d38d&"
import script from "./banner-carousel.vue?vue&type=script&lang=js&"
export * from "./banner-carousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports